import { useState } from "react";
import { entryTypes } from "@/mocks/home";

export default function EntrySection() {
  const [activeId, setActiveId] = useState(entryTypes[0].id);
  const active = entryTypes.find((e) => e.id === activeId) ?? entryTypes[0];

  return (
    <section id="entries" className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-label rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200">
            <i className="ri-list-check-2" />
            入口类型说明
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            官网入口、最新地址、发布页与永久入口，分别指什么
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
            这些说法经常一起出现，但用途并不相同。点击左侧标签，可以查看每一类入口的具体含义与查看要点，
            帮助你判断在不同情况下应当参考哪一种信息。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5">
            <div className="flex flex-col gap-3">
              {entryTypes.map((item) => {
                const isActive = item.id === activeId;
                return (
                  <button
                    key={item.id}
                    type="button"
                    onClick={() => setActiveId(item.id)}
                    aria-pressed={isActive}
                    className={`w-full text-left flex items-center gap-4 p-4 rounded-lg border transition-colors cursor-pointer ${
                      isActive
                        ? "bg-primary-50 border-primary-300"
                        : "bg-background-50 border-background-200 hover:border-primary-200"
                    }`}
                  >
                    <span
                      className={`w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-md ${
                        isActive ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                      }`}
                    >
                      <i className={`${item.icon} text-xl`} />
                    </span>
                    <span className="min-w-0">
                      <span className="block font-heading text-base font-semibold text-foreground-950">
                        {item.name}
                      </span>
                      <span className="block text-xs text-foreground-600 mt-0.5">{item.short}</span>
                    </span>
                    <i
                      className={`ml-auto text-lg ${
                        isActive ? "ri-arrow-right-s-line text-primary-600" : "ri-arrow-right-s-line text-foreground-300"
                      }`}
                    />
                  </button>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="h-full p-6 md:p-7 rounded-lg bg-background-50 border border-background-200">
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${active.icon} text-2xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-xl font-semibold text-foreground-950">{active.name}</h3>
                  <p className="text-xs text-foreground-600 mt-0.5">{active.short}</p>
                </div>
              </div>

              <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">{active.desc}</p>

              <div className="mt-6 pt-6 border-t border-background-200">
                <h4 className="text-sm font-label font-semibold text-foreground-950">查看要点</h4>
                <ul className="mt-4 space-y-3">
                  {active.points.map((p) => (
                    <li key={p} className="flex items-start gap-3">
                      <span className="mt-0.5 w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                        <i className="ri-check-line text-xs" />
                      </span>
                      <span className="text-sm leading-relaxed text-foreground-700">{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}